import { useState, useRef } from "react";
import { AnimatePresence, delay, motion, useInView } from 'framer-motion';
import emailjs from "@emailjs/browser";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { RiSendPlane2Line } from "react-icons/ri";
import BarLoader from "react-spinners/BarLoader";

import scalesOfJustice from '../assets/img/scalesOfJustice.webp'
import contactUs from '../assets/img/contactUs.webp'
import { MdDownloadDone } from "react-icons/md";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [captchaToken, setCaptchaToken] = useState("");

    const formRef = useRef(null);
    const captchaRef = useRef(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaToken) {
            alert("Please complete the CAPTCHA!");
            return;
        }

        setLoading(true);

        try {
            await emailjs.send(
                "service_gmail",  // Your EmailJS Service ID
                "template_jncm",        // Your EmailJS Template ID
                { ...formData, "g-recaptcha-response": captchaToken }, // Include captcha token
                "Vx9DC2URa_Bxm6cA3"        // Your EmailJS Public Key
            );

            setSuccess(true);
            setFormData({ name: "", email: "", subject: "", message: "" }); // Clear form
            setCaptchaToken(""); // Reset captcha
            captchaRef.current.resetCaptcha(); // Reset hCaptcha
        } catch (error) {
            console.error("Email sending failed:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <motion.div
                // ref={infoRef}
                // variants={parentVariants}
                // initial="hidden"
                // whileInView="visible" // Automatically animates when in view
                // viewport={{ once: true, amount: 0 }}
                className="relative flex xs:flex-col lg:flex-row pgMx z-[500] xs:mb-[2rem] lg:mb-[3rem] glsOutline xs:rounded-[16px] lg:rounded-[24px] shadow-2xl">
                <motion.div
                    // variants={childVariants}
                    className='xs:block lg:hidden relative z-[900] xs:h-[15rem] md:h-[25rem] lg:h-[40rem] overflow-hidden xs:rounded-t-[16px] lg:rounded-tl-0 lg:rounded-tr-[12px] lg:rounded-br-[24px]'>
                    <div
                        className="absolute top-0 left-0 bg-gradient-to-b from-black/80 via-black/30 to-black/0 z-[600] h-full w-full"
                    />
                    <img
                        src={contactUs}
                        alt="Contact Us"
                        className='object-cover w-full h-full'
                    />
                </motion.div>
                <div
                    className='lg:flex-[0.75] 2xl:flex-[1] relative z-[900] w-full h-full flex flex-col justify-center overflow-hidden xs:rounded-b-[16px] lg:rounded-tl-[24px] lg:rounded-br-[0] lg:rounded-bl-[24px] bg-gradient-to-br from-white to-chunkSky border-[3px] border-white xs:px-[1.5rem] md:px-[5rem] lg:px-[3rem] xl:px-[4rem] 2xl:px-[5rem] xs:pt-[1rem] xs:pb-[2rem] lg:py-[2rem] '
                >
                    <div
                        className='relative flex flex-row items-center justify-center space-x-[1rem]'
                    >
                        <h5
                            className="playfair introTitle introTitleTxtSize"
                        >
                            Contact Us
                        </h5>
                    </div>
                    <form onSubmit={handleSubmit} className="relative flex flex-col z-[600] gap-y-[1rem]">
                        <div className='titleUnderline' />
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder='Name'
                            className='outfit inputStyle inputHeight'
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder='Email'
                            className='outfit inputStyle inputHeight'
                            required
                        />
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder='Subject'
                            className='outfit inputStyle inputHeight'
                            required
                        />
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Your Message..."
                            className='outfit inputStyle min-h-[10rem] w-full bg-slate-100/70 border border-slate-300 xs:p-[0.75rem] lg:p-[1rem] resize-none rounded-[3px]'
                            required
                        >
                        </textarea>

                        <div className="flex justify-center">
                            <HCaptcha
                                sitekey="3638b248-99d2-4fda-91aa-235249226678" // Replace with your hCaptcha site key
                                onVerify={(token) => setCaptchaToken(token)}
                                ref={captchaRef}
                            />
                        </div>
                        <div
                            className='w-full flex items-center justify-center'
                        >
                            <button
                                type="submit"
                                disabled={loading}
                                className={`trns500 group relative z-[1000] cursor-pointer flex items-center justify-center alata btnTxtSize tracking-[0px] text-white/90 hover:text-black xs:w-full md:w-[50%] lg:w-[18rem] xl:w-[20rem] 2xl:w-[21rem] xs:h-[3.5rem] xsp:h-[4rem] lg:h-[3rem] xl:h-[3.5rem] 2xl:h-[4rem] rounded-full mx-auto border-[4px] border-slate-200/95 hover:border-slate-200 shadow-2xl outline-[4px] outline-white hover:outline-slate-900/80 btnTxtShadow ${success ? 'bg-lime-600' : 'bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen'}`}
                            >
                                {loading ? <BarLoader color="#fff" height={2} /> : success ? "Message Sent!" : "Send Message"}

                                {success ? (
                                    <MdDownloadDone
                                        className="trns500 absolute text-lime-500 group-hover:text-white xs:right-[0.5rem] md:right-[0.5rem] lg:right-[0.25rem] msgBtnIcon bg-primaryDarkestGreen border-2 border-lime-500 rounded-full"
                                    />
                                ) : (
                                    <RiSendPlane2Line
                                        className={`trns500 absolute text-white xs:right-[0.3rem] md:right-[0.5rem] lg:right-[0.25rem] msgBtnIcon rounded-full border-2 shadow-md ${loading ? 'animate-pulse bg-lime-950 border-white/0' : 'bg-white/20 group-hover:bg-slate-900 border-white/20 group-hover:border-white/0'}`}
                                    />
                                )}
                            </button>
                        </div>
                    </form>
                    <div className='absolute -top-[8%] -right-[15%] w-[70%] h-full mix-blend-multiply opacity-5 z-[500]'>
                        <img
                            src={scalesOfJustice}
                            alt="Scales of Justice"
                        />
                    </div>
                </div>
                <motion.div
                    // variants={childVariants}
                    className='flex-[1] xs:hidden lg:block relative overflow-hidden rounded-tr-[12px] rounded-br-[24px]'>
                    <div className="absolute top-0 left-0 bg-gradient-to-b from-black/80 via-black/30 to-black/0 z-[600] h-full w-full" />
                    <img
                        src={contactUs}
                        alt="Contact Us"
                        className='object-cover w-full h-full'
                    />
                </motion.div>

            </motion.div>
        </div>
    )
}

export default Contact